export default __webpack_public_path__ + "static/media/rightActive.9c061fd7.svg";